/* global window */
/* eslint-disable max-lines */
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';
import withRouter from 'HOCs/withRouter';
import PropTypes from 'prop-types';
import { Loader } from 'panamera-react-ui';
import Button from 'Components/Button/Button';
import withConfig from 'HOCs/withConfig/withConfig';
import withTrack from 'HOCs/withTrack/withTrack';
import withReplyRestriction from 'HOCs/withReplyRestriction/withReplyRestriction';
import withDirection from 'HOCs/withDirection/withDirection';
import Auth from '../../../../Auth';
import css from './ContactInfo.desktop.scss';
import ChatContainer from '../ChatContainer/ChatContainer';
import CallsContainer from '../CallsContainer/CallsContainer';
import { configSelector } from 'Selectors/config';
import { shouldShowTips } from 'Helpers/safetyTips';
import _setLoginModalState from 'Actions/setLoginModalState';
import { setOrigin } from 'Actions/track';
import { threadMeetingSelector } from 'Selectors/chat';
import { setB2CMeetingFlowType } from 'Helpers/meetings';
import { MEETING_STATUS } from 'Constants/chat';
import { LayoutHelper } from 'olx-autos-landing-page';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import { OLX_AUTOS_PHONE_IN_LISTING } from 'Constants/constants';
import { LEAD_IMPRESSION_FIELD_NAMES as FIELD_NAMES } from 'Constants/tracking';
import { isButtonVisible } from 'Helpers/tracking';
import { isCocoFofoUser } from 'Helpers/item';
import { CTA_MAP } from 'Constants/items';
import WhatsappContainer from '../WhatsappContainer/WhatsappContainer';

const SELECT_FROM_FORM = 'contact_form';

export class ContactInfo extends React.Component {
    static propTypes = {
        itemUserId: PropTypes.string.isRequired,
        toggleFirstTimeUserTips: PropTypes.func.isRequired,
        trackFilters: PropTypes.object,
        trackFiltersMetadata: PropTypes.object,
        config: PropTypes.object,
        showCtas: PropTypes.bool.isRequired,
        direction: PropTypes.oneOf(['ltr', 'rtl']).isRequired,
        onTrack: PropTypes.func.isRequired,
        trackerOrigins: PropTypes.object,
        onMessageSend: PropTypes.func.isRequired,
        tipsInitiationPoint: PropTypes.string,
        intl: PropTypes.object.isRequired,
        buttonContactType: PropTypes.string,
        leadFormName: PropTypes.string,
        leadFormFlow: PropTypes.func,
        isReplyRestricted: PropTypes.func,
        itemId: PropTypes.string,
        setLoginModalState: PropTypes.func,
        router: PropTypes.object,
        showTestDrive: PropTypes.bool,
        setOriginTrack: PropTypes.func,
        location: PropTypes.object,
        threadMeeting: PropTypes.shape({
            meetingStatus: PropTypes.string,
            date: PropTypes.string
        }).isRequired,
        track: PropTypes.func.isRequired,
        onSetFireMakeOffer: PropTypes.func,
        fireMakeOffer: PropTypes.bool,
        onClickHandler: PropTypes.func,
        showSeePhoneNumber: PropTypes.bool,
        showCallRequest: PropTypes.bool,
        showInterest: PropTypes.bool,
        showChat: PropTypes.bool,
        showCall: PropTypes.bool,
        showMakeOffer: PropTypes.bool,
        showWhatsAppCTA: PropTypes.bool,
        ivrNumber: PropTypes.string,
        trackLeadImpression: PropTypes.func,
        user: PropTypes.object,
        primaryCTA: PropTypes.string
    };

    static defaultProps = {
        trackFilters: {},
        trackFiltersMetadata: {},
        tipsInitiationPoint: '',
        buttonContactType: 'outline',
        leadFormName: '',
        leadFormFlow: () => {},
        isReplyRestricted: () => {},
        itemId: '',
        onClickHandler: () => {},
        showChat: false,
        showCall: false,
        showMakeOffer: false,
        user: {}
    };

    constructor(props) {
        super(props);

        this.state = {
            showPhone: false,
            showNumber: false
        };

        this.translations = {
            chatWithSeller: { id: 'chatWithSeller' },
            showPhone: { id: 'showPhone' },
            makeAnOffer: { id: 'makeAnOffer' },
            bookTestDrive: { id: 'bookTestDrive' },
            viewTestDrive: { id: 'viewTestDrive' },
            requestCallBack: { id: 'requestCallBack' },
            imInterested: { id: 'leadGenTxt' },
            helpTextAssertion: { id: 'helpTextAssertion' },
            helpTextAssist: { id: 'helpTextAssist' },
            whatsAppPremium: { id: 'whatsapp' }
        };

        this.showNewDesign = props.config.get('adpvAuto', 'showNewDesign');
        this.fieldNamesTracking = Object.values(FIELD_NAMES);
        this.isButtonTriggered = {};
        this.fieldNamesTracking.forEach(fieldName => {
            this.isButtonTriggered[fieldName] = React.createRef();
            this.isButtonTriggered[fieldName].current = true;
        });
        this.userType = props.user?.dealer?.car?.dealer_type;
        this.showHelpText = props.config.get('adpvAuto', 'showHelpText') && isCocoFofoUser(this.userType);
        this.isCocoItem = isCocoFofoUser(this.userType);
    }

    componentDidMount() {
        if (this.props.fireMakeOffer) {
            this.onMakeAnOfferClick({ isFromPriceCard: true });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.tipsInitiationPoint !== prevProps.tipsInitiationPoint
            && this.props.tipsInitiationPoint === 'makeAnOffer') {
            if (this.setCurrentClicked) {
                this.onMakeAnOfferClick();
            }
        }
        if (!prevProps.fireMakeOffer && prevProps.fireMakeOffer !== this.props.fireMakeOffer) {
            this.onMakeAnOfferClick({ isFromPriceCard: true });
        }

        if (this.props.trackLeadImpression) {
            this.fieldNamesTracking.forEach(fieldName => this.callTrackLeadImpression(fieldName));
        }
    }

    callTrackLeadImpression = fieldName => {
        const showBtn = isButtonVisible(fieldName, this.props.showCall, this.props.showSeePhoneNumber, this.props.showChat, this.props.showInterest, this.props.showTestDrive);

        if (this.isButtonTriggered[fieldName].current && showBtn) {
            this.props.trackLeadImpression(this.props.onTrack, fieldName);
            this.isButtonTriggered[fieldName].current = !this.isButtonTriggered[fieldName].current;
        }
    };

    trackAction = (event, extraTrackAttr = {}, select_from = 'contact_form') => {
        this.props.onTrack(event, {
            origin: this.props.trackerOrigins.ITEM_PAGE,
            filters: this.props.trackFilters,
            select_from,
            ...this.props.trackFiltersMetadata,
            ...extraTrackAttr,
            seller_id: this.props.itemId
        });
    };

    showPhoneNumberFlow = requestPhone => () => {
        return requestPhone(true)
            .then(() => {
                this.setState({ showPhone: true });
            });
    }

    showPNKycCb = requestPhone => {
        // eslint-disable-next-line consistent-return
        return () => {
            if (this.props.leadFormName) {
                this.props.leadFormFlow(this.showPhoneNumberFlow(requestPhone), 'onTapCall');
            }
            else {
                return this.showPhoneNumberFlow(requestPhone)();
            }
        };
    }

    showPhoneNumber = requestPhone => {
        this.trackAction('item_call_button_press');
        if (!this.props.isReplyRestricted(this.props.itemId, this.props.itemUserId, this.showPNKycCb(requestPhone), true)) {
            this.showPNKycCb(requestPhone)();
        }

        return null;
    };

    onCallClickHandler = callback => () => {
        if (this.state.showPhone) {
            const { location } = this.props;
            const extraTrackAttr = {
                chosen_option: 'call_now',
                ...LayoutHelper.getAcquisitionChannelTrackingValues()
            };

            if (location && location.state && location.state.feed_version) {
                extraTrackAttr.feed_version = location.state.feed_version;
            }
            this.trackAction('item_tap_call', extraTrackAttr);
        }
        else {
            this.trackAction('item_tap_phone');
        }
        if (this.props.leadFormName) {
            return this.props.leadFormFlow(callback, 'onTapCall');
        }
        return callback();
    };

    onChatClickHandler = callback => () => {
        if (!Auth.isLoggedIn()) {
            this.trackAction('item_intent_chat');
        }
        callback('contact_form');
    };

    makeAnOfferKycCb = () => {
        if (this.props.leadFormName) {
            this.props.leadFormFlow(this.makeAnOfferFlow, 'onTapChat');
        }
        else {
            this.makeAnOfferFlow();
        }
    }

    onMakeAnOfferClick = params => {
        const isReplyRestricted = this.props.isReplyRestricted(this.props.itemId, this.props.itemUserId, this.makeAnOfferKycCb, true, true);

        if (!isReplyRestricted) {
            this.makeAnOfferKycCb();
        }

        if (params?.isFromPriceCard) {
            this.props.onSetFireMakeOffer(false);
        }
    };

    makeOfferFlowKycCb = (chatRedirect, user, origin) => {
        return () => {
            if (!this.props.config.get('firstTimeSafetyTip') || (!shouldShowTips())) {
                const { location } = this.props;
                const extraTrackAttr = {};

                if (location && location.state && location.state.feed_version) {
                    extraTrackAttr.feed_version = location.state.feed_version;
                }

                this.props.onTrack(
                    'item_chat_tap_make_offer',
                    Object.assign(
                        {
                            item_id: this.props.itemId,
                            seller_id: this.props.itemUserId,
                            user_id: user.id,
                            origin
                        },
                        { filters: this.props.trackFilters },
                        this.props.trackFiltersMetadata,
                        extraTrackAttr
                    )
                );
                this.props.router.push({
                    pathname: chatRedirect,
                    hash: '#offer'
                }, {
                    state: {
                        index: 0
                    }
                });
            }
            else {
                this.props.toggleFirstTimeUserTips('makeAnOffer');
                this.setCurrentClicked = 'make_an_offer_control';
            }
        };
    }

    makeAnOfferFlow = () => {
        const chatRedirect = `/nf/chat/new/${this.props.itemId}/${this.props.itemUserId}`;
        const origin = this.props.trackerOrigins.ITEM_PAGE;

        this.props.setOriginTrack(origin);

        if (Auth.isLoggedIn()) {
            const user = Auth.getUser();

            if (!this.props.isReplyRestricted(this.props.itemId, this.props.itemUserId, this.makeOfferFlowKycCb(chatRedirect, user, origin))) {
                this.makeOfferFlowKycCb(chatRedirect, user, origin)();
            }
        }
        else {
            this.props.setLoginModalState({
                state: true,
                redirectTo: '',
                trackProps: { origin },
                entryPoint: 1,
                callback: this.onMakeAnOfferClick
            });
        }
    }

    renderMakeAnOfferButton = () => {
        const user = Auth.getUser();
        const { showTestDrive, showMakeOffer } = this.props;

        if (showMakeOffer && !this.showNewDesign && user && user.id !== this.props.itemUserId) {
            return (
                <Button
                    data-aut-id="btnMakeAnOffer"
                    type={ showTestDrive ? 'secondaryBtn' : this.props.buttonContactType }
                    size="small"
                    className={ css.makeAnOffer }
                    onClick={ this.onMakeAnOfferClick }>
                    <span>{ this.props.intl.formatMessage(this.translations.makeAnOffer) }</span>
                </Button>
            );
        }

        return null;
    }

    handleMeetingClick = () => {
        const {
            track,
            itemId,
            itemUserId,
            threadMeeting,
            router,
            setLoginModalState,
            showTestDrive
        } = this.props;

        if (!Auth.isLoggedIn()) {
            setLoginModalState({
                state: true,
                callback: () => {
                    this.handleMeetingClick();
                }
            });
        }
        else if (showTestDrive) {
            setB2CMeetingFlowType('adpage');
            track('chat_tap_meeting', {
                flow_type: 'adpage',
                field_name: 'store_test_drive',
                posting_variant: 'B2C',
                item_id: itemId,
                seller_id: itemUserId,
                buyer_id: Auth.getUser()?.id
            });
            track('tap_view_meeting', {
                flow_type: 'adpage',
                field_name: 'store_test_drive',
                posting_variant: 'B2C',
                item_id: itemId,
                seller_id: itemUserId,
                buyer_id: Auth.getUser()?.id,
                num_variants_shown: threadMeeting?.date
            });
            if (threadMeeting.meetingStatus === MEETING_STATUS.ACCEPTED) {
                router.push(`/meeting/confirmation/${itemId}`);
            }
            else {
                router.push(`/meeting/pick-date/${itemId}`);
            }
        }
    }

    toggleShowNumber = () => {
        this.setState({ showNumber: !this.state.showNumber });
        const extraTrackAttr = {};

        extraTrackAttr.chosen_option = 'call_now';
        this.trackAction('item_tap_interested', extraTrackAttr);
    }

    makeCall = () => {
        const extraTrackAttr = {
            ...LayoutHelper.getAcquisitionChannelTrackingValues()
        };

        extraTrackAttr.chosen_option = 'call_now';
        this.trackAction('item_tap_call', extraTrackAttr);
        window.open(`tel:${this.props.ivrNumber}`);
    }

    onClickShowNumber = () => (this.state.showNumber ? this.makeCall() : this.toggleShowNumber())

    getHelpTextButtons = () => {
        return (<div data-aut-id="helpText" className={ css.helpTextButtons }>
            <span className={ css.helpTextAssertion }>{this.props.intl.formatMessage(this.translations.helpTextAssertion)} </span>
            <span className={ css.helpTextAssist }>{this.props.intl.formatMessage(this.translations.helpTextAssist)}</span>
        </div>);
    }

    handleWhatsAppClick = (phone, clickHandler, requestPhoneForWhatsapp, params) => {
        if (phone) {
            clickHandler(phone);
        }
        else {
            requestPhoneForWhatsapp(params);
        }
    }

    render() {
        const { showTestDrive, threadMeeting, showSeePhoneNumber, ivrNumber, primaryCTA, showWhatsAppCTA } = this.props;
        const callHandler = requestPhone => () => this.showPhoneNumber(requestPhone);
        const trackingProps = {
            origin: this.props.trackerOrigins.ITEM_PAGE,
            filters: this.props.trackFilters,
            select_from: SELECT_FROM_FORM,
            ...this.props.trackFiltersMetadata
        };

        const btnSize = this.showNewDesign ? 'normal' : 'small';
        // const btnChatType = (showTestDrive || showSeePhoneNumber || this.showNewDesign) ? 'secondaryBtn' : this.props.buttonContactType;
        const shouldShowHelpText = this.showHelpText && (showSeePhoneNumber || showTestDrive || this.props.showChat || this.props.showCallRequest || this.props.showInterest);

        return (
            <React.Fragment>
                { this.props.showCtas && <React.Fragment>
                    {shouldShowHelpText && <>
                        <div className={ css.separator } />
                        {this.getHelpTextButtons()}
                    </>}
                    {showSeePhoneNumber
                        && <Button
                            data-aut-id="btnSeePhoneNum"
                            type={ CTA_MAP.SHOW_SEE_PHONE_NUMBER_CTA === primaryCTA ? 'primary' : 'secondaryBtn' }
                            size={ btnSize }
                            className={ css.meeting }
                            onClick={ this.onClickShowNumber }
                        >
                            {this.state.showNumber
                                ? (<span>{ivrNumber}</span>) : (
                                    <span>{ this.props.intl.formatMessage(this.translations.showPhone) }</span>
                                )
                            }
                        </Button>
                    || null }
                    {showTestDrive
                        && <Button
                            data-aut-id="btnMeeting"
                            type={ CTA_MAP.SHOW_TEST_DRIVE_CTA === primaryCTA ? 'primary' : 'secondaryBtn' }
                            size={ btnSize }
                            className={ css.meeting }
                            onClick={ this.handleMeetingClick }
                        >
                            <span>{ this.props.intl.formatMessage(
                                threadMeeting.meetingStatus === MEETING_STATUS.ACCEPTED
                                    ? this.translations.viewTestDrive
                                    : this.translations.bookTestDrive
                            )}</span>
                        </Button>
                    || null }
                    {this.props.showCallRequest
                        && <Button
                            data-aut-id="btnCallRequested"
                            type={ CTA_MAP.SHOW_CALL_REQUEST_CTA === primaryCTA ? 'primary' : 'secondaryBtn' }
                            size={ btnSize }
                            className={ css.meeting }
                            onClick={ this.props.onClickHandler }
                        >
                            <span>{ this.props.intl.formatMessage(this.translations.requestCallBack) }</span>
                        </Button>
                    || null }
                    {this.props.showInterest
                        && <Button
                            data-aut-id="btnImInterested"
                            type={ CTA_MAP.SHOW_INTEREST_CTA === primaryCTA ? 'primary' : 'secondaryBtn' }
                            size={ btnSize }
                            className={ css.meeting }
                            onClick={ this.props.onClickHandler }
                        >
                            <span>{ this.props.intl.formatMessage(this.translations.imInterested) }</span>
                        </Button>
                    || null }

                    {showWhatsAppCTA
                        && (<WhatsappContainer
                            userId={ this.props.itemUserId }
                            itemId={ this.props.itemId }
                            track={ this.props.track }
                        >
                            {
                                ({ phone, clickHandler, requestPhoneForWhatsapp, isFetchingPhone }) => {
                                    return (<>
                                        <Button
                                            onClick={ () => this.handleWhatsAppClick(phone, clickHandler, requestPhoneForWhatsapp, { action: 'tapOnWhatsapp' }) }
                                            type={ CTA_MAP.SHOW_WHATSAPP_CTA === primaryCTA ? 'primary' : 'secondaryBtn' }
                                            key="whatsapp"
                                            icon={ 'whatsapp' }
                                            data-aut-id="whatsappBtn"
                                            className={ classnames(css.ctaButton, css.whatsappCta) }
                                        >
                                            { this.props.intl.formatMessage(this.translations.whatsAppPremium) }
                                            {isFetchingPhone && <div className={ css.loaderWhatsApp }>
                                                <Loader />
                                            </div>}
                                        </Button>
                                    </>);
                                }
                            }
                        </WhatsappContainer>)
                    }

                    {this.props.showChat
                    && <ChatContainer
                        toggleFirstTimeUserTips={ this.props.toggleFirstTimeUserTips }
                        onMessageSend={ this.props.onMessageSend }
                        tipsInitiationPoint={ this.props.tipsInitiationPoint }
                        onTrack={ this.props.onTrack }
                        experimentVariant="phone_number_challenge"
                        selectFrom="contact_form"
                        leadFormName={ this.props.leadFormName }
                        leadFormFlow={ this.props.leadFormFlow }>
                        {({ clickHandler }) => (
                            <Button
                                data-aut-id="btnChat"
                                type={ CTA_MAP.SHOW_CHAT_CTA === primaryCTA ? 'primary' : 'secondaryBtn' }
                                size={ btnSize }
                                fixed
                                className={ css.ctaButton }
                                icon={ 'chat' }
                                onClick={ this.onChatClickHandler(clickHandler()) }>
                                { this.props.intl.formatMessage(this.translations.chatWithSeller) }
                            </Button>
                        )}
                    </ChatContainer>}

                    {this.props.showCall
                        ? <CallsContainer
                            tipsInitiationPoint={ this.props.tipsInitiationPoint }
                            toggleFirstTimeUserTips={ this.props.toggleFirstTimeUserTips }
                            onTrack={ this.props.onTrack }
                            trackerOrigins={ this.props.trackerOrigins }
                            trackingProps={ trackingProps }
                            experimentVariant="phone_number_challenge">
                            {({ clickHandler, isFetchingPhone, requestPhone, phone }) => {
                                if (isFetchingPhone) {
                                    return (
                                        <div className={ css.loader }>
                                            <Loader />
                                        </div>
                                    );
                                }

                                return (
                                    <div className={ css.phoneWrapper }>
                                        <span className={ css.phoneIcon }>
                                            <Icon icon="call" size={ 26 } color={ phone ? 'primary' : 'blackText' } direction={ this.props.direction } />
                                        </span>
                                        { this.state.showPhone && phone
                                            ? (
                                                <div
                                                    className={ css.numberPhone }
                                                    onClick={ this.onCallClickHandler(clickHandler(true, false)) }>
                                                    { phone }
                                                </div>
                                            ) : (
                                                <React.Fragment>
                                                    <div>
                                                        { this.props.config.get('phoneFormat') }
                                                    </div>
                                                    <div
                                                        className={ css.showPhoneNumber }
                                                        onClick={ callHandler(requestPhone) }>
                                                        { this.props.intl.formatMessage(this.translations.showPhone) }
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }
                                    </div>
                                );
                            }}
                        </CallsContainer> : null
                    }

                </React.Fragment>
                }

            </React.Fragment>
        );
    }
}

export const mapStateToProps = (state, { itemUserId, itemId }) => {
    const generalConfig = configSelector(state);
    const phoneInListing = generalConfig?.features?.find(feature => feature.name === OLX_AUTOS_PHONE_IN_LISTING) || {};
    const ivrNumber = phoneInListing?.enabled && phoneInListing.data?.number || '';

    return {
        trackFilters: state.track.filters,
        trackFiltersMetadata: state.track.filtersMetadata,
        trackOrigin: state.track.origin,
        threadMeeting: threadMeetingSelector(state, { userId: itemUserId, itemId }),
        ivrNumber,
        user: state.users.elements[itemUserId]
    };
};

export const mapDispatchToProps = dispatch => ({
    setLoginModalState: state => dispatch(_setLoginModalState(state)),
    setOriginTrack: origin => dispatch(setOrigin(origin))
});

export default compose(
    injectIntl,
    withTrack,
    withDirection,
    withConfig,
    withReplyRestriction,
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ContactInfo);
